var _g, _g2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _circle, _rect9, _rect0, _rect1, _rect10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 194,
    viewBox: "0 0 229 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6202_59750)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.9148,
    y: 187.383,
    width: 152.698,
    height: 196.542,
    rx: 12,
    transform: "rotate(-99.9571 29.9148 187.383)",
    fill: "#F6F4F4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6202_59750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4297 169.607C19.8023 169.607 14.4297 164.235 14.4297 157.607L14.4297 28.9097C14.4297 22.2823 19.8023 16.9097 26.4297 16.9097L198.971 16.9097C205.599 16.9097 210.971 22.2823 210.971 28.9097L210.971 157.607C210.971 164.235 205.599 169.607 198.971 169.607L26.4297 169.607Z",
    fill: "#FCFAF9"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.9492,
    y: 137.98,
    width: 167.504,
    height: 17.1768,
    rx: 3.31213,
    fill: "#EBE9E9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.9497,
    y: 110.994,
    width: 17,
    height: 4,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 52.0664,
    y: 110.994,
    width: 124.59,
    height: 4,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28.9492,
    y: 118.994,
    width: 12,
    height: 4,
    rx: 2,
    fill: "#EBE9E9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 52.0664,
    y: 118.994,
    width: 82.0586,
    height: 4,
    rx: 2,
    fill: "#EBE9E9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 28.9492,
    y: 63.5781,
    width: 50.6824,
    height: 32.6124,
    rx: 3.31213,
    fill: "#EBE9E9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 87.3599,
    y: 63.5781,
    width: 50.6824,
    height: 32.6124,
    rx: 3.31213,
    fill: "#EBE9E9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 145.771,
    y: 63.5781,
    width: 50.6824,
    height: 32.6124,
    rx: 3.31213,
    fill: "#EBE9E9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.5029,
    cy: 42.2744,
    r: 11.5537,
    fill: "#D9D9D9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 59.0566,
    y: 44.2754,
    width: 39,
    height: 4,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 59.0566,
    y: 44.2754,
    width: 39,
    height: 4,
    rx: 2,
    fill: "#EBE9E9"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 59.0566,
    y: 36.2754,
    width: 61.3008,
    height: 4,
    rx: 2,
    fill: "#D9D9D9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 163.357,
    y: 35.3203,
    width: 32.7109,
    height: 13.9082,
    rx: 3,
    fill: "#3158F2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6202_59750",
    x: 0.403809,
    y: 0.892578,
    width: 228.2,
    height: 192.598,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6202_59750"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6202_59750",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6202_59750",
    x: 10.4297,
    y: 12.9102,
    width: 208.542,
    height: 164.697,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6202_59750"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6202_59750",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDocuments);
export default __webpack_public_path__ + "static/media/no-documents.bdd81f210ee4b3620d707fb54ce34d99.svg";
export { ForwardRef as ReactComponent };